import { WhiteBox, FoodsIllustrations } from "@foodpilot/foods";
import { Stack, styled, Typography } from "@mui/material";

type EmptyCardProps = {
    direction?: "row" | "column";
    title: string;
    subtitle: string;
};

export const EmptyCard = (props: EmptyCardProps) => {
    const { direction = "column", title, subtitle } = props;
    return (
        <EmptyComparisonCard direction={direction} key={`empty-card-${direction}-${title}-${subtitle}`}>
            <FoodsIllustrations illustration="notEnoughData" width={112} height={112} />
            <Stack gap={1}>
                <Typography variant="h4">{title}</Typography>
                <Typography variant="body1">{subtitle}</Typography>
            </Stack>
        </EmptyComparisonCard>
    );
};

export const EmptyComparisonCard = styled(WhiteBox)<{ direction: "row" | "column" }>(
    ({ theme, direction = "column" }) => ({
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: theme.spacing(4),
        flexDirection: direction,
        padding: theme.spacing(4),
        textAlign: direction === "row" ? "left" : "center",
        [theme.breakpoints.down("md")]: {
            border: "none",
            padding: theme.spacing(2),
            boxShadow: "none",
        },
    }),
);
